import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import { Container, Row, Col } from 'reactstrap';
import {isIOS, isSafari, isMobile,isTablet, isBrowser} from 'react-device-detect';
import {CardMedia} from 'material-ui/Card';
import './index.css'
import {Link} from 'react-router-dom';

const tournaments = [13,14]

class AddTournamentConnectedNew extends PureComponent {

    static propTypes = {
        actions: PropTypes.shape({
            enterPage: PropTypes.func,
            leavePage: PropTypes.func,
        })
    };

    constructor(props) {
        super(props);
        this.state = {
            venues: [],
            game_types: [],
            tournament_details: {
                venue: '',
                name: '',
                game_type: '',
                date: new Date().toISOString().slice(0, 10),
                time: '00:00',
                age_groups:[],
                amount:'',
                category:'',
                game:'',
                gender:'',
                event:''
            },
            data_uploaded: false,
            data_error: false,
            first_screen:true,
            categories:[],
            age_groups:[],
            genders:[],
            tournament_id:'',
            games:[],
            selected_events:false,
            filtered_venues:[],
            selected_venue:''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGameType = this.handleGameType.bind(this);
        this.getTournamentInputs = this.getTournamentInputs.bind(this);
        this.handleEventChange = this.handleEventChange.bind(this);
        this.EmptyVenueList = this.EmptyVenueList.bind(this);
    }

    componentDidMount() {
        this.getTournamentInputs();
    }
 
    getTournamentInputs() {
        const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_structure/`;
        const options = {...defaultOptions};
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            const uniqueValues = {};
            var games_filter = data.game_types.map((info)=>({"name":info.game,"icon":info.game_icon}))
            var games = games_filter.filter((game,index)=>{ 
                    var value = game['name']
                    if (!uniqueValues.hasOwnProperty(value)) {
                      uniqueValues[value] = true;
                      return true;
                    }
                    return false;
            } )
            this.setState({ 
                venues: data.venues,game_types:data.game_types,
                games:games
              
            });
        })
       .catch(error => error);
    }  
  
    postaddTournament(data, props) {
        console.log(data);
        var empty_data = false
        const url = `${getLocationOrigin()}/eagleeye/create_tournament/`;
        const options = {...defaultOptions};
        var formData = new FormData();
        for(var name in data) {
            formData.append(name, data[name]);
        }
        options['method'] = 'post';
        options['body'] = formData;
        console.log('Going to fetch');
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){
            alert(response.message);
            window.location.href=`https://www.events.sporthood.in/#/crud/viewTournament/${response.tournament_id}`
        })
        .catch(error => {
            console.log(error);
            alert(error.message);
        });
    
    }
    handleVenueChange(venue){
        var new_selected_one =  Object.assign({}, this.state.tournament_details);
        new_selected_one['venue'] = venue.id
        this.setState({tournament_details:new_selected_one, selected_venue:venue.name,filtered_venues:[]})
    }
    handleGameType(value){
        console.log("handleGameType")
        var new_selected_one =  Object.assign({}, this.state.tournament_details);
        new_selected_one['game'] = value
        if(value=='Events'){
            new_selected_one['event'] = 'Events'
            new_selected_one['game_type'] = 22
            this.setState({selected_events:true})
        }
        else{
            new_selected_one['event'] = ''
            new_selected_one['game_type'] = ''
            this.setState({selected_events:false})
        }
        
        this.setState({tournament_details: new_selected_one});
    }
    handleEventChange(value){
        console.log("handleEventChange",this.state.tournament_details['game'])
        if(!this.state.tournament_details['game']){
            window.alert('Please select game first ')
        }
        else{
            var new_selected_one =  Object.assign({}, this.state.tournament_details);
            new_selected_one['event'] = value
            var game_type = this.state.game_types.filter(info=>info.name==value && info.game== this.state.tournament_details['game'])
            if (game_type && game_type.length>0){
                var game_type_id = game_type[0].pk
                new_selected_one['game_type'] = game_type_id
            }
            if(value!='Events'){
                this.getCompetitionDetails()
            }
            this.setState({tournament_details: new_selected_one});
        }
        
    }
    
    handleChange(event) {
        console.log("handleChange",event.target.value)
        const name = event.target.name;
        var new_selected_one =  Object.assign({}, this.state.tournament_details);
        var filtered_venues =[]
        if(name=='venue'){
            new_selected_one[name] = event.target.value
            this.setState({selected_venue:event.target.value})
            if(event.target.value == '')
                filtered_venues = this.state.venues.slice(0,10)
            else{
                filtered_venues = this.state.venues.filter(venue=> (venue.name.toLowerCase().indexOf(event.target.value) !== -1))
                if(filtered_venues && filtered_venues.length>10){
                    filtered_venues = filtered_venues.slice(0,10)
                }
            }
        }
        else if(name=='age_groups'){
            if(new_selected_one['age_groups'] && new_selected_one['age_groups'].includes(event.target.value))
                new_selected_one['age_groups'] = new_selected_one['age_groups'].filter(info=>info!=event.target.value)
            else
                new_selected_one['age_groups'].push(event.target.value)
        }
        else{
            new_selected_one[name] = event.target.value
        }
        this.setState({tournament_details: new_selected_one,filtered_venues:filtered_venues});
    }

    goBack(){
        this.props.history.goBack();
    }

    handleSubmit(event) {
        console.log("handleSubmit",this.state.tournament_details.game_type,this.state.tournament_details.age_groups.length)

        if(this.state.tournament_details.name==""){
          alert("Please enter name")
        }
        else if(this.state.tournament_details.game_type==""){
          alert("Please select game and type")
        }
        else if(this.state.tournament_details.venue==""){
          alert("Please select a venue")
        }
        else if(this.state.tournament_details.game_type==13 && !this.state.tournament_details.age_groups.length>0){
            alert("Please select age groups")
        }
        else if( (this.state.tournament_details.game_type ==14 ||this.state.tournament_details.game_type ==81) &&
        ((!this.state.tournament_details.age_groups.length>0)||(this.state.tournament_details.category == '')||
            (this.state.tournament_details.gender == '') )){
            alert("All fields are mandatory")
        }
        else{
            var new_selected_one =  Object.assign({}, this.state.tournament_details);
            this.postaddTournament(this.state.tournament_details, this.props);  
        } 
    }
    getCompetitionDetails() {
        const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_competition/?tournament_id=`;
        const options = {...defaultOptions};
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({ 
                categories: data.categories,
                age_groups: data.age_groups, 
                genders: data.genders,
            });
        })
       .catch(error => error);
    }
    EmptyVenueList(){
        setTimeout(() => this.setState({filtered_venues:[]}), 500);
    }
    
    renderCompetitionForm(){
        console.log("ttt_____",this.state.tournament_details)
        return(
            <div className="add_tournament_body">
                {(this.state.tournament_details.game=="Swimming" || this.state.tournament_details.game=='Badminton')&& this.state.genders.length>0 &&
                    <Row  xs='12' md='12' className="add_tournament_add_field">
                        <Col xs='1' md='2' className="add_tournament_add_field_label">Gender</Col>
                        <Col xs='2' md='4' className="add_tournament_add_field_input">
                            <select name="gender" onChange={(e)=>{this.handleChange(e)}} value={this.state.tournament_details.gender} className="add_tournament_add_field_input_box">
                                <option value=''>---------</option>
                                {this.state.genders.length>0 && this.state.genders.map((gender,index)=>(
                                    <option value={gender[0]}>{gender[1]}</option>
                                ))}
                            </select>
                        </Col>
                    </Row>
                }
                {(this.state.tournament_details.game=="Swimming" || this.state.tournament_details.game=='Badminton') && this.state.categories.length>0 &&
                    <Row  xs='12' md='12' className="add_tournament_add_field">
                        <Col xs='1' md='2' className="add_tournament_add_field_label">Categories</Col>
                        <Col xs='2' md='4' className="add_tournament_add_field_input">
                            <select name="category" onChange={(e)=>{this.handleChange(e)}} value={this.state.tournament_details.category} className="add_tournament_add_field_input_box">
                                <option value=''>---------</option>
                                {this.state.categories.length>0 && this.state.categories.map((category,index)=>(
                                    <option value={category[0]}>{category[1]}</option>
                                ))}
                            </select>
                        </Col>
                    </Row>
                }
                {this.state.age_groups.length>0 &&
                    <Row  xs='12' md='12' className="add_tournament_add_field">
                        <Col xs='1' md='2' className="add_tournament_add_field_label">Age Grops</Col>
                        <Col xs='2' md='4' className="add_tournament_add_field_input">
                            <select name="age_groups" multiple onChange={(e)=>{this.handleChange(e)}} value={this.state.tournament_details.age_groups} className="add_tournament_add_field_input_box">
                                {this.state.age_groups.map((group,index)=>(
                                    <option value={group.id}>{group.name}</option>
                                ))}
                            </select>
                        </Col>
                    </Row>
                }
                <Row  xs='12' md='12' className="add_tournament_add_field">
                    <Col xs='1' md='2' className="add_tournament_add_field_label">Registration Amount</Col>
                    <Col xs='2' md='4' className="add_tournament_add_field_input">
                        <input name="amount" onChange={(e)=>{this.handleChange(e)}} value={this.state.tournament_details.amount} className="add_tournament_add_field_input_box" type="text"/>
                    </Col>
                </Row>
                <Row  xs='12' md='12' className="add_tournament_add_field">
                    <Col xs='2' md='2' onClick={()=>{this.handleSubmit()}} className="add_tournament_add_field_submit">
                        <div className=""> Submit </div>
                    </Col>
                </Row>
            </div>
        )
    }

    renderAddTournament(){
        return(
            <div className="add_tournament_body">
                <Row className="add_tournament_game_selector">
                    {this.state.games.map((game,key)=>(
                        <Col md='2' xs='3' name="game" className={game.name==this.state.tournament_details.game?"add_tournament_game_selector_box add_tournament_game_selector_selected": "add_tournament_game_selector_box"} 
                            onClick={()=>{this.handleGameType(game.name)}}>
                            <img className="add_tournament_game_selector_icon" src={game.icon}/>
                            <div className="add_tournament_game_selector_name" >{game.name.toLowerCase()=='events'? 'Others' : game.name}</div>
                        </Col>
                    ))}
                </Row>
                {!this.state.selected_events &&
                    <Row className="add_tournament_add_field">
                            <Col xs='2' md='3' className="add_tournament_add_field_label">
                                <div className={this.state.tournament_details.event=='Tournament'?"add_tournament_add_field_radio_box add_tournament_radio_box_selected":"add_tournament_add_field_radio_box"} onClick={()=>{this.handleEventChange('Tournament')}}>
                                   Tournament
                                </div>
                            </Col>
                        
                            <Col xs='2' md='3' className="add_tournament_add_field_label">
                                <div className={this.state.tournament_details.event=='Events'?"add_tournament_add_field_radio_box add_tournament_radio_box_selected":"add_tournament_add_field_radio_box"} onClick={()=>{this.handleEventChange('Events')}}>
                                    Events
                                </div>
                            </Col>
                    </Row>
                }
                <Row  xs='12' md='12' className="add_tournament_add_field">
                    <Col xs='1' md='2' className="add_tournament_add_field_label">Name</Col>
                    <Col xs='2' md='4' className="add_tournament_add_field_input">
                        <input name="name" onChange={(e)=>{this.handleChange(e)}} value={this.state.tournament_details.name} className="add_tournament_add_field_input_box" type="text"/>
                    </Col>
                </Row>
                <Row  xs='12' md='12' className="add_tournament_add_field">
                    <Col xs='1' md='2' className="add_tournament_add_field_label">Venue</Col>
                    <Col xs='2' md='4' className="add_tournament_add_field_input" style={{position:'relative'}}>
                        <input name="venue" onBlur={()=>{this.EmptyVenueList() }} onChange={(e)=>{this.handleChange(e)}} value={this.state.selected_venue} className="add_tournament_add_field_input_box" type="text"/> 
                        {this.state.filtered_venues.length>0 &&
                            <div className="add_tournament_venue_filter">
                                {this.state.filtered_venues.map((venue,index)=>(
                                    <div className="add_tournament_venue_filter_list" onClick={(e)=>{e.preventDefault(),this.handleVenueChange(venue)}} >{venue.name}</div>
                                ))}
                            </div>
                        }
                    </Col>
                </Row>
                <Row  xs='12' md='12' className="add_tournament_add_field">
                    <Col xs='1' md='2' className="add_tournament_add_field_label">Date & Time</Col>
                    <Col xs='2' md='4' className="add_tournament_add_field_input">
                        <input name="date" onChange={(e)=>{this.handleChange(e)}} value={this.state.tournament_details.date} className="add_tournament_add_field_input_dt" type="date" />
                        <input name="time" onChange={(e)=>{this.handleChange(e)}} value={this.state.tournament_details.time} className="add_tournament_add_field_input_dt" type="time" />
                    </Col>
                </Row>
                {this.state.tournament_details.event=='Events' &&
                    <Row  xs='12' md='12' className="add_tournament_add_field">
                        <Col xs='1' md='2' className="add_tournament_add_field_label">Registration Amount</Col>
                        <Col xs='2' md='4' className="add_tournament_add_field_input">
                            <input name="amount" onChange={(e)=>{this.handleChange(e)}} value={this.state.tournament_details.amount} className="add_tournament_add_field_input_box" type="text"/>
                        </Col>
                    </Row>
                }
                
                {this.state.tournament_details.event!='Events' ?
                    <Row  xs='12' md='12' className="add_tournament_add_field">
                        <Col xs='2' md='2' onClick={()=>{this.setState({first_screen:false})}} className="add_tournament_add_field_submit add_tournament_next_btn">
                            <div className=""> Next </div>
                        </Col>
                    </Row>
                :
                    <Row  xs='12' md='12' className="add_tournament_add_field">
                        <Col xs='2' md='2' onClick={()=>{this.handleSubmit()}} className="add_tournament_add_field_submit">
                            <div className=""> Submit </div>
                        </Col>
                    </Row>
                }
            </div>
        )
    }
    render() {
        return(
            <div className="add_tournament">
                <div className="back_button_box">
                <Link to='/' className="back_button_link">
                    <div className="tour_back_button">Back</div>
                </Link>
                </div>
                <div className="add_tournament_outer">

                    <div className="add_tournament_main_head">
                        {!this.state.first_screen  && <div className="add_tournament_main_back" onClick={()=>{this.setState({first_screen:true})}}> &#8592;&nbsp;Back</div>}
                        <div>Add Tournament</div>
                    </div>
                    {this.state.game_types.length>0 ?
                        <div className="add_tournament_outer_container">
                            {this.state.first_screen && this.renderAddTournament()}
                            {!this.state.first_screen && this.renderCompetitionForm()}
                        </div>
                    :
                        <div>Loading...</div>   
                    }
                </div>
            </div>
        );
    }
}

export default AddTournamentConnectedNew;




// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournament/addTournamentnew.js